import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { DropDownList } from "../../../models/DropDownList.model";
import { UserSearchModel } from "../../../models/UserSearch.model";
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { UserService } from "../../../services/user.service";
import { CommonHelper } from "../../../shared/helpers/CommonHelper";
import { ErrorHandlerProvider } from "../../../shared/providers/errorHandler.provider";
import { ToastsManager } from "ng2-toastr";
import { Router } from '@angular/router';
import { User } from "../../../models/User.model";
import { Roles, RoleSearch } from "../../../models/Roles.model";
import { ExcellenceCentersService } from "../../../services/excellenceCenters.service";
import { IndustriesService } from "../../../services/industries.service";
import * as _ from 'lodash';

type DimensionData = {
    data: DropDownList[]
    selected: DropDownList[]
    options: {};
}

@Component({
    selector: "app-users-create",
    templateUrl: "./users-create.component.html",
    styleUrls: ["./users-create.component.scss"]
})
export class UsersCreateComponent implements OnInit {
    @ViewChild("buttonDeactiveUserModal") openDeactivateUserModal: ElementRef;
    emailPattern = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    userForm: FormGroup;
    loading: boolean = false;
    userSearchModel: UserSearchModel = new UserSearchModel();
    roleSearch: RoleSearch = new RoleSearch({ active: true, systemic: false });

    user: User = new User();
    types: string[];
    roles: Roles[] = [];

    industries;
    excellenceCenters;
    supportCenters;
    fieldsEnabled = {};
    userDimensionsValid = false;
    constructor(
        private formBuilder: FormBuilder,
        public commonHelper: CommonHelper,
        private userService: UserService,
        private errorHandler: ErrorHandlerProvider,
        private toastr: ToastsManager,
        private router: Router,
        private excellenceCentersService: ExcellenceCentersService,
        private industriesService: IndustriesService,
    ){};

    async ngOnInit(): Promise<void> {
        this.loading = true;
        this.user.type = "";
        this.userForm = this.formBuilder.group({
            name: [null, Validators.required],
            username: [null, Validators.required],
            role: [null, [this.validateSelectOption]],
        });

        this.types = this.commonHelper.getAllInternalRoles();
        this.roles = await this.userService.getRoles(this.roleSearch);

        const allCenters = await this.excellenceCentersService.getAll();
        this.excellenceCenters = allCenters.filter(center => center.type == 1 );
        this.excellenceCenters = _.orderBy(this.excellenceCenters, [sup => sup.name.toUpperCase()]);

        this.supportCenters = allCenters.filter(center => center.type == 2 );
        this.supportCenters = _.orderBy(this.supportCenters, [sup => sup.name.toUpperCase()]);

        this.industries = await this.industriesService.getAll();

        this.buildDimensionsSelects();
        this.roleChange();
        this.loading = false;
    };

    buildDimensionsSelects(): void {
        const dimensionValues = {
            industries: ['Setor', 'SETORES'],
            excellenceCenters: ['Centro de Excelência', 'CENTROS DE EXCELÊNCIA'],
            supportCenters: ['Área de Suporte', 'ÁREAS DE SUPORTE']
        };

        const dimensionFields = this.getDimensionValues();
        for (const field of dimensionFields) {
            const [dimensionWord, dimensionPluralWord] = dimensionValues[field];
            const conditional = dimensionWord.toLowerCase() == 'Área de Suporte'.toLowerCase() ? 'TODAS AS' : 'TODOS OS';
            const options = this.commonHelper.getDropDownSettings(false, dimensionWord, true, `MARCAR ${conditional} ${dimensionPluralWord}`, `DESMARCAR ${conditional} ${dimensionPluralWord}`, true, null, '');;
            const dimension: DimensionData = {
                data: this.commonHelper.getDropDownListItems(this[field], "_id", "name"),
                selected: [],
                options: {},
            };
            this[field] = dimension;
            this[field].options = options;
        }
    }

    verifyUserDimensions(dimensionName: string) {
        this.userDimensionsValid = true;
        const optionalRoles = ['governance', 'manager', 'commercial'];
        if (this.user.type && optionalRoles.some(role => role === this.user.type)) {
            return;
        };

        if (this[dimensionName].selected.length) {
            return
        };

        this.userDimensionsValid = false;
    }

    async Onsave() {
        try {
            if (!this.user.type || this.user.type === "") {
                this.toastr.warning("Selecione um cargo para o usuário.", "ATENÇÃO");
                return;
            };

            if (!this.userDimensionsValid) {
                this.toastr.warning("Selecione um eixo obrigatório.", "ATENÇÃO");
                return;
            }

            this.buildUserDimensions();
            this.loading = true;
            let response = await this.userService.create(this.user);
            this.loading = false;

            if (response._id) {
                this.toastr.success('Usuário criado com sucesso!');
                this.router.navigate(['/users']);
            } else {
                this.errorHandler.interceptError(response, 'Usuário');
            }
        } catch (err) {
            this.errorHandler.interceptError(err, 'Usuário');
            this.loading = false;
        }
    }

    cancel() {
        this.router.navigate(['/users']);
    }

    verifyValidTouched(fieldName) {
        return !this.userForm.get(fieldName).valid && this.userForm.get(fieldName).touched;
    }

    validateSelectOption(control: AbstractControl) {
        if (!control.value || control.value == "")
            return {role: true};
        return null;
    }

    applyErrorCss(fieldName) {
        return {
            'has-error': this.verifyValidTouched(fieldName)
        }
    }

    async verifyEmailUser(){
        if(!this.user.username){
            this.toastr.warning("O Email é obrigatório!");
        }else{
            if(!(new RegExp(this.emailPattern).test((this.user.username).toString()))) {
                this.toastr.warning(`Digite um email válido.`, "Email inválido!");
                this.user.username = "";
            }
        }
    }

    verifyNameMask(rawValue: string): RegExp[] {
        const mask = /[A-Za-zÁ-Úá-úÀ-Ùà-ùÃ-Õã-õÄ-Üä-üÂ-Ûâ-ûÇç' ']/;
        const strLength = String(rawValue).length;
        const nameMask: RegExp[] = [];
        for (let i = 0; i <= strLength; i++) {
          nameMask.push(mask);
        }
        return nameMask
    }

    getDimensionValues(): string[] {
        return ['excellenceCenters', 'industries', 'supportCenters'];
    }

    roleChange(): void {
        const setDimensionsSelectDisabled = this.getDimensionValues();
        const role = this.roles.find(role => role.type === this.user.type);

        if (!role || !role.complementaryFields.length) {
            setDimensionsSelectDisabled.forEach(field => {
                this[field].options = {
                    ...this[field].options,
                    disabled: true
                }
                this[field].selected = [];
                this.fieldsEnabled[field] = false;
            });
            this.userDimensionsValid = true;
            return;
        }

        setDimensionsSelectDisabled.forEach(field => {
            this[field].options = {
                ...this[field].options,
                disabled: true
            }
            this[field].selected = [];
            this.fieldsEnabled[field] = false;
        });

        const optionalRoles = ['governance', 'manager', 'commercial'];
        role.complementaryFields.forEach((compf) => {
            this[compf.field].options = {
                ...this[compf.field].options,
                disabled: optionalRoles.includes(role.type) ? compf.required : !compf.required
            };
            this.fieldsEnabled[compf.field] = compf.required;
        });

        this.userDimensionsValid = optionalRoles.some(role => role === this.user.type);
    }

    buildUserDimensions() {
        const dimensions = this.getDimensionValues();

        for (const dimension of dimensions) {
            if (this[dimension].selected.length) {
                const formattedDimensionArray = this[dimension].selected.map((item: DropDownList) => {
                    return {
                        _id: item.id,
                        name: item.itemName
                    }
                })
                this.user[dimension] = formattedDimensionArray;
            }
        }
    }

    trimName(): void {
        if (this.user.name) this.user.name = this.user.name.trim();
    }
}



// WEBPACK FOOTER //
// ./src/app/views/users/users-create/users-create.component.ts